import { InjectionToken } from '@angular/core';
import { AppType, BuildType } from '@domains';

export const RSPL_UI_CONFIG = new InjectionToken<RsplUiConfig>('config');

export interface RsplUiConfig {
    app: AppType;
    buildType: BuildType;
}